import { render, staticRenderFns } from "./SpaceFormUpdate.vue?vue&type=template&id=579b8d02&scoped=true"
import script from "./SpaceFormUpdate.vue?vue&type=script&lang=ts"
export * from "./SpaceFormUpdate.vue?vue&type=script&lang=ts"
import style0 from "./SpaceFormUpdate.vue?vue&type=style&index=0&id=579b8d02&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579b8d02",
  null
  
)

export default component.exports